import Vue from 'vue'
import VueRx from 'vue-rx'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { sync } from 'vuex-router-sync' // vuex help to manage the data like user login token; vuex-router-sync helps to sync storage with router
import App from './App.vue'

Vue.config.productionTip = false

Vue.use(VueRx) // vuejs-clipper dependency

// sync router state with vue-router
sync(store, router)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
